/**
 * Lazy loader for walletService (ethers + @web3modal).
 * Keeps the heavy web3 graph off the main.ts / App.vue / layout first-paint path.
 * Call only when connect / silent reconnect / deposit / chain ops actually need it.
 */

type WalletServiceInstance = typeof import('./walletService').walletService;

let cached: Promise<WalletServiceInstance> | null = null;

export function getWalletService(): Promise<WalletServiceInstance> {
  if (!cached) {
    cached = import('./walletService')
      .then((m) => m.walletService)
      .catch((err) => {
        // 失败勿污染缓存，否则弱网下会一直卡到整页刷新
        cached = null;
        throw err;
      });
  }
  return cached;
}

/** Returns the in-flight/loaded promise without starting a new dynamic import. */
export function getWalletServiceIfLoaded(): Promise<WalletServiceInstance> | null {
  return cached;
}
